import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SelectFieldComponent } from '../../../../components/form/select-field/select-field.component';
import { SelectOption } from '../../../../components/form/select-field/select-field.config';
import { MeetingMinuteRowsBase } from '../meeting-minute-rows/meeting-minute-rows.base';

import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

@Component({
  selector: 'meeting-minute-participants',
  imports: [ReactiveFormsModule, SelectFieldComponent],
  templateUrl: './meeting-minute-participants.component.html',
  styleUrl: '../meeting-minute-rows/meeting-minute-rows.scss'
})
export class MeetingMinuteParticipantsComponent extends MeetingMinuteRowsBase {

  @Input() userOptions: SelectOption[] = [];
  @Input() statusOptions: SelectOption[] = [];

  protected readonly idControlName = 'meetingMinuteParticipantId';
  protected readonly rowLabel = 'participant';

  constructor(confirmationDialogService: ConfirmationDialogService) {
    super(confirmationDialogService);
  }
}
